import React, { useState, useEffect } from "react";
import { ConfigurationTab } from "./index";
import { AgentLayout } from "./AgentLayout";
import { useParams } from "@tanstack/react-router";
import { sampleAgents } from "../AIAgentsPage";

export const ConfigurationPage: React.FC = () => {
  const { agentId } = useParams({ from: "/ai-agents/$agentId" });
  const [agent, setAgent] = useState<any>(null);

  // Load agent data from sessionStorage
  useEffect(() => {
    try {
      const storedAgents = sessionStorage.getItem("ai-agents");
      if (storedAgents) {
        const agents = JSON.parse(storedAgents).map((agent: any) => ({
          ...agent,
          lastActive: new Date(agent.lastActive),
        }));

        // Find the specific agent by ID
        const foundAgent = agents.find((a: any) => a.id === agentId);
        if (foundAgent) {
          setAgent(foundAgent);
        } else {
          // Fallback to sample agents
          const sampleAgent = sampleAgents.find((a: any) => a.id === agentId);
          if (sampleAgent) {
            setAgent(sampleAgent);
          }
        }
      } else {
        // No sessionStorage data, check sample agents
        const sampleAgent = sampleAgents.find((a: any) => a.id === agentId);
        if (sampleAgent) {
          setAgent(sampleAgent);
        }
      }
    } catch (error) {
      console.error("Error loading agent data:", error);
    }
  }, [agentId]);

  return (
    <AgentLayout activeTab="configuration">
      {agent && <ConfigurationTab agent={agent} />}
    </AgentLayout>
  );
};
